<template>
  <div class="page">

    <div class="content">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <div class="bottom"  v-if=" WinHeight >  WinWidth  ">
      <div class="fixed-bar">
        <mu-paper>
          <!--<mu-bottom-nav :value="bottomNav" shift @change="handleChange"  >-->
          <mu-bottom-nav :value="bottomNav" shift v-on:change="handleChange"    >
            <mu-bottom-nav-item :value="homeIndex" title="首页" icon="home" iconClass="bottomIconColor" />
            <mu-bottom-nav-item value="/home/order" title="订单" icon="library_books" iconClass="bottomIconColor" />
            <mu-bottom-nav-item value="/home/wallet" title="格林钱包" icon="credit_card" iconClass="bottomIconColor" />
            <!--<mu-bottom-nav-item value="/user/login" title="我" icon="account_circle"/>-->
            <mu-bottom-nav-item value="/user/Login" title="我" icon="account_circle" iconClass="bottomIconColor" />

          </mu-bottom-nav>
        </mu-paper>
      </div>
    </div>

    <!--下方通用  END-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>
<script>

import { mapGetters } from 'vuex'


export default {
  name: 'bottomNav',
  data() {
    return {
      homeIndex:'/home/index',
      bottomNav: '/home/index',
      bottomNavColor: '/home/index',

      // 弹出层 弹出内容
      toast: false,
      TellUser: '',
      // 弹出层 弹出内容  END

      WinHeight:'',
      WinWidth:'',
     
      IsShow:true,
      
    }
  },
  activated() {
    this.bottomNav = this.$route.path;
    // 首页动态配置
    var newUrl = sessionStorage.getItem(window.location.hostname + "_homeUrl");
    if(newUrl!=null && newUrl != undefined && newUrl!=''){
        this.homeIndex = newUrl;
    }

    if (this.$route.path == '/user/UserCenter' || this.$route.path == '/user/OtherUser'   ) {
      this.bottomNav = '/user/Login'
    }
    else if (this.$route.path == '/home/IndexToOther') {
      this.bottomNav = '/home/order'
    }


  },
  watch: {
    $route(to, from) {

      if (to.path == '/user/UserCenter' || to.path == '/user/OtherUser') {
        this.bottomNav = '/user/Login'
      }
      else if (to.path == '/home/IndexToOther' || to.path == '/home/order') {
        this.bottomNav = '/home/order'
      }
      else if (to.path == '/home/wallet') {
        this.bottomNav = '/home/wallet'
      }
      else if (to.path == '/home/index') {
        this.bottomNav = '/home/index'
      }
      else if(to.path == '/home/jdindex'){
        this.bottomNav = '/home/jdindex';
      }
      else if(to.path == '/search/list'){
        this.bottomNav = '/search/list';
      }
    }
  },




  
  methods: {
    handleChange(val) {

      this.bottomNav = val;

      // // 除了首页，别的页面没有身份信息，就跳入登录页
      if (val != "/home/index") {
        // alert(this.g_UserInfo.Card_no)
        if (this.g_UserInfo.Card_no == '' || this.g_UserInfo.Card_no == undefined) {
          // console.log(this.g_UserInfo.OtherUserID)

          // 没有卡号，判断是不是协议用户，是的话，说明是协议用户登录了      
          if (this.g_UserInfo.IsOtherUser) {

            if (val == "/user/Login") {
              this.bottomNav = '/user/Login'
            }
            else {
              val = '/home/IndexToOther';
              this.bottomNav = '/home/order'
            }
          }
          else {

            val = '/user/Login';
            this.TellUser = "请先登录";
            this.showToast();
          }
        }
      }

      this.$router.push({ path: val });

    },



    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end 

    resize(){
      this.WinHeight = document.documentElement.clientHeight
      this.WinWidth = document.documentElement.clientWidth

      console.log(this.WinHeight)
      console.log(this.WinWidth)
    },


  },
  mounted() {

    this.resize()


    var that = this;
    // document.getElementById("apppage").onresize = function(){
    // window.onresize = () => {
    window.onresize = () => {
        return (() => {
            that.resize();
        })()
    }

  },

  computed: {
    ...mapGetters([
      'g_UserInfo',
    ])
  },


}


</script>


<style lang="less">
@import "../../assets/theme.less";
.page {
  .bottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 999;
    .mu-bottom-nav-shift {
      background-color: #FFF;
      .mu-buttom-item-wrapper {
        .bottomIconColor {
          color: @primaryColor;
        }
        .mu-bottom-item-text {
          color: @primaryColor;
        }
      }
    }
  }
  .fixed-bar {
    max-width: 480px;
    width: 100%;
  }
}
</style>






// WEBPACK FOOTER //
// home.vue?30b354b6